var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_2096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0075 3.35727C9.85514 3.35727 9.71748 3.41432 9.60964 3.50547L9.60396 3.49981L4.74458 8.34247C4.19389 8.89303 3.96811 9.43017 3.96522 10.197C3.96522 10.7967 4.18682 11.3362 4.58907 11.7161C5.00451 12.1082 5.58149 12.3155 6.25789 12.3154H6.27209C6.97616 12.3123 7.63497 12.0352 8.12658 11.5361L13.7651 5.89892C15.1932 4.47067 15.2306 2.43517 13.8542 1.05862C13.1715 0.375983 12.2626 0 11.2948 0C10.327 0 9.4183 0.375983 8.73611 1.05867L1.67404 8.11974C-0.126372 9.92018 -0.126372 12.8498 1.67404 14.6502C2.54479 15.5207 3.70428 16 4.93892 16C6.17358 16 7.33316 15.5207 8.20427 14.6501L15.5153 7.31325C15.5153 7.31325 15.6764 7.15487 15.6764 6.88773C15.6764 6.54546 15.3988 6.2679 15.0566 6.2679C14.8939 6.2679 14.747 6.332 14.6364 6.43459L14.6345 6.43269L7.32335 13.7697C6.68743 14.4052 5.84058 14.7553 4.93879 14.7553C4.03699 14.7553 3.19027 14.4052 2.55459 13.7697C1.23974 12.4543 1.23974 10.3149 2.55459 9.00042L9.61666 1.93946C10.0642 1.49197 10.6601 1.24557 11.2948 1.24557C11.9295 1.24557 12.5258 1.49207 12.9736 1.93946C13.4203 2.38609 13.6448 2.91666 13.623 3.47405C13.6015 4.0226 13.3462 4.55659 12.8845 5.01828L7.2342 10.6674C6.97589 10.926 6.63246 11.0691 6.26768 11.0699C5.57379 11.0699 5.21076 10.6328 5.21076 10.2015C5.21216 9.83707 5.35507 9.49377 5.61338 9.23507L10.4846 4.3806L10.479 4.37508C10.5702 4.26721 10.6273 4.12958 10.6273 3.97723C10.6273 3.63468 10.3497 3.35727 10.0075 3.35727Z",
    fill: "#04BA96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.708785ec5f76ff7c4c4a8a701412e2ba.svg";
export { ForwardRef as ReactComponent };